import { Controller } from '@hotwired/stimulus'
import { addClass, removeClass } from 'utils/toggle_class'

export default class extends Controller {
  onScroll() {
    if (window.scrollY > 200) {
      removeClass(this.element, "-invisible")
    } else {
      addClass(this.element, "-invisible")
    }
  }
}
